import styled from 'styled-components';
const TablePageStyled = styled.div`
  background-color: rgb(253, 253, 253);
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  flex-grow: 1;
`;
export default TablePageStyled;
